import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'wl-html-content-view',
  templateUrl: './html-content-view.component.html',
  styleUrls: ['./html-content-view.component.less'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})
export class HtmlContentViewComponent {
  @Input() html: any;
  constructor() {}
}
